<template>
  <div class="question">
    <p class="question-txt">{{ questionData.question }}</p>

    <div class="slider-meat">
      <el-slider
        v-model="questionData.value"
        :step="1"
        :min="0"
        :max="4"
        :show-tooltip="false"
        @change="updateStore"
        >
      </el-slider>
      <div class="slider__stops-container">
        <div class="slider-stop"></div>
        <div class="slider-stop"></div>
        <div class="slider-stop"></div>
        <div class="slider-stop"></div>
        <div class="slider-stop"></div>
      </div>
    </div>

    <div class="slider__labels">
      <div class="" v-for="(label, index) in questionData.labels" :key="index">
        <div class="title" v-html="label.title"></div>
        <div class="example" v-html="label.example"></div>
      </div>
    </div>

    <div class="question-footer">
      <Btn class="next-btn" type="primary-orange" theme="white" :hasIcon="false" @click="next">Next</Btn>
    </div>
  </div>
</template>

<script>
import { Slider } from 'element-ui'
import Btn from '@/components/Btn'

export default {
  name: 'Question2',
  metaInfo() {
   // if no subcomponents specify a metaInfo.title, this title will be used
   return {
     title: 'Examine your eating',
     titleTemplate: ' %s - Question 2'
   }
  },
  props: [],
  components: {
    'el-slider': Slider,
    Btn
  },
  data() {
    return {

    }
  },
  computed: {
    questionData() {
      return this.$store.state.DietImpact.questions[1]
    }
  },
  methods: {
    next() {
      this.$store.commit('DietImpact/NEXT_PAGE')
      this.$parent.$parent.$refs.quiz.scrollTo({ top: 0, behavior: 'smooth' });
    },
    updateStore() {
      let val = this.questionData.value
      this.$store.commit('DietImpact/UPDATE_MEAT_MULTIPLIER', val)
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/styles/vars';
  .slider__labels {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    > div {
      width: 112px;
      text-align: left;
      &:nth-of-type(2) {
        text-align: center;
      }
      &:nth-of-type(3) {
        text-align: right;
      }
    }
    .title {
      font-family: $fSecondary;
      font-weight: $fwMed;
      font-size: 15px;
      line-height: 19.79px;
      text-transform: uppercase;
      color: #696969;
      margin-bottom: 10px;
    }
    .example {
      font-family: $fPrimary;
      font-weight: $fwReg;
      font-size: 12px;
      line-height: 15.65px;
      color: $cGrayTxt;
    }
  }

  .slider-meat {
    margin: 0 auto 14px;
    width: 93%;
    position: relative;
    .slider__stops-container {
      width: 100%;
      position: absolute;
      display: flex;
      top: 50%;
      transform: translateY(-50%);
      .slider-stop {
        height: 10px;
        width: 2px;
        background-color: #E6E6E6;
        position: absolute;
        top: 50%;
        transform: translate(0%, -50%);
        &:nth-of-type(2) {
          left: 25%;
          transform: translate(-25%, -50%);
        }
        &:nth-of-type(3) {
          left: 50%;
          transform: translate(-50%, -50%);
        }
        &:nth-of-type(4) {
          left: 75%;
          transform: translate(-75%, -50%);
        }
        &:nth-of-type(5) {
          left: 100%;
          transform: translate(-100%, -50%);
        }
      }
    }
  }

  .el-slider__runway {
    height: 2px;
    background-color: #F5F5F5;
  }
  .el-slider__bar {
    display: none;
  }
  .el-slider__button {
    height: 24px;
    width: 25px;
    background-color: $cOrange;
    border: none;
  }
</style>
